/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал передачи сообщений.
 * Это альтернативный путь передачии команд в реальном времени в exchange минуя NATS
 */

/**
 * Сервис передачи сообщений
 */
export class MessageServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  // method PostMessageFullDuplex(bidirectional streams) not supported yet

  /**
   * Метод отправки задач и получения их результатов выполнения.
   * Метод доступен для: admin, service, application(exchange:edit)
   */
  PostMessagePushCall = (req: PostMessagePushCallRequestDto, init?: RequestInit): Promise<PostMessagePushCallResponseDto> => {
    return fm.request<PostMessagePushCallRequestDto, PostMessagePushCallResponseDto>(`${this.host}/exchange/api/v1/message_push_call`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод отправки задач и получения их результатов выполнения для мобильного приложения.
   * Метод доступен для: admin, service
   */
  PostMessageMobilePushCall = (req: PostMessageMobilePushCallRequestDto, init?: RequestInit): Promise<PostMessageMobilePushCallResponseDto> => {
    return fm.request<PostMessageMobilePushCallRequestDto, PostMessageMobilePushCallResponseDto>(`${this.host}/exchange/api/v1/message_mobile_push_call`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип пуш-токена
 */
export enum MessageMobilePushCallPushCallType {
  /**
   * Не указан
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Для Mobile Firebase Cloud Messaging
   */
  MOBILE_FCM = "MOBILE_FCM",
  /**
   * Для Mobile Huawei Messaging System
   */
  MOBILE_HMS = "MOBILE_HMS",
  /**
   * Для Mobile Apple PushToken System для текста
   */
  MOBILE_APNS_TEXT = "MOBILE_APNS_TEXT",
  /**
   * Для Mobile Apple PushToken System для звонков
   */
  MOBILE_APNS_CALL = "MOBILE_APNS_CALL",
  /**
   * Для Mobile RuStore
   */
  MOBILE_RUSTORE = "MOBILE_RUSTORE",
}
/**
 * Тип пуш-токена
 */
export type MessageMobilePushCallPushCallTypeResponseEnum = keyof typeof MessageMobilePushCallPushCallType
/**
 * Тип пуш-токена
 */
export type MessageMobilePushCallPushCallTypeRequestEnum = Exclude<MessageMobilePushCallPushCallTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Тип пуш-токена
 */
export enum MessagePushCallPushCallType {
  /**
   * Не указан
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Для PWA Firebase Cloud Messaging
   */
  PWA_FCM = "PWA_FCM",
  /**
   * Для PWA Apple Notification System
   */
  PWA_APNS = "PWA_APNS",
}
/**
 * Тип пуш-токена
 */
export type MessagePushCallPushCallTypeResponseEnum = keyof typeof MessagePushCallPushCallType
/**
 * Тип пуш-токена
 */
export type MessagePushCallPushCallTypeRequestEnum = Exclude<MessagePushCallPushCallTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Звонковое сообщение для мобильных приложений
 */
export type MessageMobilePushCallRequestDto = {
  /**
   * Сообщение
   */
  message: MessageMobilePushCallMessageRequestDto
  /**
   * Звонковый пуш
   */
  pushCall: MessageMobilePushCallPushCallRequestDto
}
/**
 * Звонковое сообщение для мобильных приложений
 */
export type MessageMobilePushCallResponseDto = {
  /**
   * Сообщение
   */
  message: MessageMobilePushCallMessageResponseDto
  /**
   * Звонковый пуш
   */
  pushCall: MessageMobilePushCallPushCallResponseDto
}
/**
 * Сообщение
 */
export type MessageMobilePushCallMessageRequestDto = {
  /**
   * Заголовок уведомления
   */
  title: string
  /**
   * Идентификатор устройства источника
   */
  deviceId: number
  /**
   * Название устройства источника
   */
  deviceTitle?: string | null
  /**
   * Идентификатор камеры устройства источника.
   * Тип: Guid
   */
  deviceCameraId?: string | null
  /**
   * SIP-токен
   */
  sipToken: string
  /**
   * Адрес SIP сервера
   */
  sipServerHost?: string | null
  /**
   * Порт SIP сервера
   */
  sipServerPort?: number | null
  /**
   * Логин SIP аккаунта
   */
  sipAccountLogin?: string | null
  /**
   * Пароль SIP аккаунта
   */
  sipAccountPassword?: string | null
  /**
   * Адрес STUN сервера
   */
  stunServerHost?: string | null
  /**
   * Порт STUN сервера
   */
  stunServerPort?: number | null
  /**
   * Момент инициации звонка
   */
  callCreatedAt: string
}
/**
 * Сообщение
 */
export type MessageMobilePushCallMessageResponseDto = {
  /**
   * Заголовок уведомления
   */
  title: string
  /**
   * Идентификатор устройства источника
   */
  deviceId: number
  /**
   * Название устройства источника
   */
  deviceTitle: string | null
  /**
   * Идентификатор камеры устройства источника.
   * Тип: Guid
   */
  deviceCameraId: string | null
  /**
   * SIP-токен
   */
  sipToken: string
  /**
   * Адрес SIP сервера
   */
  sipServerHost: string | null
  /**
   * Порт SIP сервера
   */
  sipServerPort: number | null
  /**
   * Логин SIP аккаунта
   */
  sipAccountLogin: string | null
  /**
   * Пароль SIP аккаунта
   */
  sipAccountPassword: string | null
  /**
   * Адрес STUN сервера
   */
  stunServerHost: string | null
  /**
   * Порт STUN сервера
   */
  stunServerPort: number | null
  /**
   * Момент инициации звонка
   */
  callCreatedAt: string
}
/**
 * Звонковый пуш
 */
export type MessageMobilePushCallPushCallRequestDto = {
  /**
   * Пуш-токен адресата звонка
   */
  token: string
  /**
   * Тип пуш-токена
   */
  type: MessageMobilePushCallPushCallTypeRequestEnum
}
/**
 * Звонковый пуш
 */
export type MessageMobilePushCallPushCallResponseDto = {
  /**
   * Пуш-токен адресата звонка
   */
  token: string
  /**
   * Тип пуш-токена
   */
  type: MessageMobilePushCallPushCallTypeResponseEnum
}
/**
 * Звонковое сообщение
 */
export type MessagePushCallRequestDto = {
  /**
   * Сообщение
   */
  message: MessagePushCallMessageRequestDto
  /**
   * Звонковый пуш
   */
  pushCall: MessagePushCallPushCallRequestDto
}
/**
 * Звонковое сообщение
 */
export type MessagePushCallResponseDto = {
  /**
   * Сообщение
   */
  message: MessagePushCallMessageResponseDto
  /**
   * Звонковый пуш
   */
  pushCall: MessagePushCallPushCallResponseDto
}
/**
 * Сообщение
 */
export type MessagePushCallMessageRequestDto = {
  /**
   * Заголовок уведомления
   */
  title: string
  /**
   * Идентификатор устройства источника
   */
  deviceId: number
  /**
   * Название устройства источника
   */
  deviceTitle?: string | null
  /**
   * Идентификатор камеры устройства источника.
   * Тип: Guid
   */
  deviceCameraId?: string | null
  /**
   * Адрес SIP сервера
   */
  sipServerHost: string
  /**
   * Порт SIP сервера
   */
  sipServerPort: number
  /**
   * Логин SIP аккаунта
   */
  sipAccountLogin: string
  /**
   * Пароль SIP аккаунта
   */
  sipAccountPassword: string
  /**
   * Момент инициации звонка
   */
  callCreatedAt: string
}
/**
 * Сообщение
 */
export type MessagePushCallMessageResponseDto = {
  /**
   * Заголовок уведомления
   */
  title: string
  /**
   * Идентификатор устройства источника
   */
  deviceId: number
  /**
   * Название устройства источника
   */
  deviceTitle: string | null
  /**
   * Идентификатор камеры устройства источника.
   * Тип: Guid
   */
  deviceCameraId: string | null
  /**
   * Адрес SIP сервера
   */
  sipServerHost: string
  /**
   * Порт SIP сервера
   */
  sipServerPort: number
  /**
   * Логин SIP аккаунта
   */
  sipAccountLogin: string
  /**
   * Пароль SIP аккаунта
   */
  sipAccountPassword: string
  /**
   * Момент инициации звонка
   */
  callCreatedAt: string
}
/**
 * Звонковый пуш
 */
export type MessagePushCallPushCallRequestDto = {
  /**
   * Пуш-токен адресата звонка
   */
  token: string
  /**
   * Тип пуш-токена
   */
  type: MessagePushCallPushCallTypeRequestEnum
}
/**
 * Звонковый пуш
 */
export type MessagePushCallPushCallResponseDto = {
  /**
   * Пуш-токен адресата звонка
   */
  token: string
  /**
   * Тип пуш-токена
   */
  type: MessagePushCallPushCallTypeResponseEnum
}
/**
 * Поток отправляемых событий
 */
export type PostMessageFullDuplexRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * task
 */
& fm.OneOf<{
  /**
   * Отправка звонкового сообщения
   */
  readonly postMessagePushCall: PostMessagePushCallRequestDto
}>
/**
 * Поток ответов на задачи
 */
export type PostMessageFullDuplexResponseDto = {
  /**
   * Идентификатор ответа
   */
  requestId: string
}
/**
 * event
 */
& fm.OneOf<{
  /**
   * Ответ на отправку звонкового сообщения
   */
  readonly postMessagePushCall: PostMessagePushCallResponseDto
}>
/**
 * Запрос на отправку звонкового пуш сообщения для мобильного приложения
 */
export type PostMessageMobilePushCallRequestDto = {
  /**
   * Звонковый пуш
   */
  data: MessageMobilePushCallRequestDto
}
/**
 * Ответ на запрос на отправку звонкового пуш сообщения для мобильного приложения
 */
export type PostMessageMobilePushCallResponseDto = {
}
/**
 * Запрос на отправку звонкового пуш сообщения
 */
export type PostMessagePushCallRequestDto = {
  /**
   * Звонковый пуш
   */
  data: MessagePushCallRequestDto
}
/**
 * Ответ на запрос на отправку звонкового пуш сообщения
 */
export type PostMessagePushCallResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Звонковое сообщение для мобильных приложений
   */
  "MessageMobilePushCall": {
    "kind": "class",
    "text": "Звонковое сообщение для мобильных приложений",
    "fields": {
      /**
       * Сообщение
       */
      "message": {
        "type": "MessageMobilePushCall.Message",
        "text": "Сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Звонковый пуш
       */
      "pushCall": {
        "type": "MessageMobilePushCall.PushCall",
        "text": "Звонковый пуш",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Сообщение
   */
  "MessageMobilePushCall.Message": {
    "kind": "class",
    "text": "Сообщение",
    "fields": {
      /**
       * Заголовок уведомления
       */
      "title": {
        "type": "string",
        "text": "Заголовок уведомления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства источника
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства источника",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Название устройства источника
       */
      "deviceTitle": {
        "type": "google.protobuf.StringValue",
        "text": "Название устройства источника",
      },
      /**
       * Идентификатор камеры устройства источника.
       * Тип: Guid
       */
      "deviceCameraId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор камеры устройства источника.\nТип: Guid",
      },
      /**
       * SIP-токен
       */
      "sipToken": {
        "type": "string",
        "text": "SIP-токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Адрес SIP сервера
       */
      "sipServerHost": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес SIP сервера",
      },
      /**
       * Порт SIP сервера
       */
      "sipServerPort": {
        "type": "google.protobuf.Int32Value",
        "text": "Порт SIP сервера",
      },
      /**
       * Логин SIP аккаунта
       */
      "sipAccountLogin": {
        "type": "google.protobuf.StringValue",
        "text": "Логин SIP аккаунта",
      },
      /**
       * Пароль SIP аккаунта
       */
      "sipAccountPassword": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль SIP аккаунта",
      },
      /**
       * Адрес STUN сервера
       */
      "stunServerHost": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес STUN сервера",
      },
      /**
       * Порт STUN сервера
       */
      "stunServerPort": {
        "type": "google.protobuf.Int32Value",
        "text": "Порт STUN сервера",
      },
      /**
       * Момент инициации звонка
       */
      "callCreatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Момент инициации звонка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Звонковый пуш
   */
  "MessageMobilePushCall.PushCall": {
    "kind": "class",
    "text": "Звонковый пуш",
    "fields": {
      /**
       * Пуш-токен адресата звонка
       */
      "token": {
        "type": "string",
        "text": "Пуш-токен адресата звонка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип пуш-токена
       */
      "type": {
        "type": "MessageMobilePushCall.PushCall.Type",
        "text": "Тип пуш-токена",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Звонковое сообщение
   */
  "MessagePushCall": {
    "kind": "class",
    "text": "Звонковое сообщение",
    "fields": {
      /**
       * Сообщение
       */
      "message": {
        "type": "MessagePushCall.Message",
        "text": "Сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Звонковый пуш
       */
      "pushCall": {
        "type": "MessagePushCall.PushCall",
        "text": "Звонковый пуш",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Сообщение
   */
  "MessagePushCall.Message": {
    "kind": "class",
    "text": "Сообщение",
    "fields": {
      /**
       * Заголовок уведомления
       */
      "title": {
        "type": "string",
        "text": "Заголовок уведомления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства источника
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства источника",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Название устройства источника
       */
      "deviceTitle": {
        "type": "google.protobuf.StringValue",
        "text": "Название устройства источника",
      },
      /**
       * Идентификатор камеры устройства источника.
       * Тип: Guid
       */
      "deviceCameraId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор камеры устройства источника.\nТип: Guid",
      },
      /**
       * Адрес SIP сервера
       */
      "sipServerHost": {
        "type": "string",
        "text": "Адрес SIP сервера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Порт SIP сервера
       */
      "sipServerPort": {
        "type": "int32",
        "text": "Порт SIP сервера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Логин SIP аккаунта
       */
      "sipAccountLogin": {
        "type": "string",
        "text": "Логин SIP аккаунта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль SIP аккаунта
       */
      "sipAccountPassword": {
        "type": "string",
        "text": "Пароль SIP аккаунта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Момент инициации звонка
       */
      "callCreatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Момент инициации звонка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Звонковый пуш
   */
  "MessagePushCall.PushCall": {
    "kind": "class",
    "text": "Звонковый пуш",
    "fields": {
      /**
       * Пуш-токен адресата звонка
       */
      "token": {
        "type": "string",
        "text": "Пуш-токен адресата звонка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип пуш-токена
       */
      "type": {
        "type": "MessagePushCall.PushCall.Type",
        "text": "Тип пуш-токена",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Поток отправляемых событий
   */
  "PostMessageFullDuplexRequest": {
    "kind": "class",
    "text": "Поток отправляемых событий",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Отправка звонкового сообщения
       */
      "postMessagePushCall": {
        "type": "PostMessagePushCallRequest",
        "text": "Отправка звонкового сообщения",
      },
    },
  },
  /**
   * Поток ответов на задачи
   */
  "PostMessageFullDuplexResponse": {
    "kind": "class",
    "text": "Поток ответов на задачи",
    "fields": {
      /**
       * Идентификатор ответа
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор ответа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ответ на отправку звонкового сообщения
       */
      "postMessagePushCall": {
        "type": "PostMessagePushCallResponse",
        "text": "Ответ на отправку звонкового сообщения",
      },
    },
  },
  /**
   * Запрос на отправку звонкового пуш сообщения для мобильного приложения
   */
  "PostMessageMobilePushCallRequest": {
    "kind": "class",
    "text": "Запрос на отправку звонкового пуш сообщения для мобильного приложения",
    "fields": {
      /**
       * Звонковый пуш
       */
      "data": {
        "type": "MessageMobilePushCall",
        "text": "Звонковый пуш",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на отправку звонкового пуш сообщения для мобильного приложения
   */
  "PostMessageMobilePushCallResponse": {
    "kind": "class",
    "text": "Ответ на запрос на отправку звонкового пуш сообщения для мобильного приложения",
  },
  /**
   * Запрос на отправку звонкового пуш сообщения
   */
  "PostMessagePushCallRequest": {
    "kind": "class",
    "text": "Запрос на отправку звонкового пуш сообщения",
    "fields": {
      /**
       * Звонковый пуш
       */
      "data": {
        "type": "MessagePushCall",
        "text": "Звонковый пуш",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на отправку звонкового пуш сообщения
   */
  "PostMessagePushCallResponse": {
    "kind": "class",
    "text": "Ответ на запрос на отправку звонкового пуш сообщения",
  },
  /**
   * Тип пуш-токена
   */
  "MessageMobilePushCall.PushCall.Type": {
    "kind": "enum",
    "text": "Тип пуш-токена",
    "values": {
      /**
       * Не указан
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Не указан",
      },
      /**
       * Для Mobile Firebase Cloud Messaging
       */
      "MOBILE_FCM": {
        "i": 1,
        "text": "Для Mobile Firebase Cloud Messaging",
      },
      /**
       * Для Mobile Huawei Messaging System
       */
      "MOBILE_HMS": {
        "i": 2,
        "text": "Для Mobile Huawei Messaging System",
      },
      /**
       * Для Mobile Apple PushToken System для текста
       */
      "MOBILE_APNS_TEXT": {
        "i": 3,
        "text": "Для Mobile Apple PushToken System для текста",
      },
      /**
       * Для Mobile Apple PushToken System для звонков
       */
      "MOBILE_APNS_CALL": {
        "i": 4,
        "text": "Для Mobile Apple PushToken System для звонков",
      },
      /**
       * Для Mobile RuStore
       */
      "MOBILE_RUSTORE": {
        "i": 5,
        "text": "Для Mobile RuStore",
      },
    },
  },
  /**
   * Тип пуш-токена
   */
  "MessagePushCall.PushCall.Type": {
    "kind": "enum",
    "text": "Тип пуш-токена",
    "values": {
      /**
       * Не указан
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Не указан",
      },
      /**
       * Для PWA Firebase Cloud Messaging
       */
      "PWA_FCM": {
        "i": 1,
        "text": "Для PWA Firebase Cloud Messaging",
      },
      /**
       * Для PWA Apple Notification System
       */
      "PWA_APNS": {
        "i": 2,
        "text": "Для PWA Apple Notification System",
      },
    },
  },
}